<template>
  <header v-bind:class="{ 'close': close }">
    <div class="l-container">
      <h1>
        <router-link to="/">
          <svg class="header__logo" width="110px" height="68px" viewBox="644 275 110 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <desc>株式会社マスターマインズ</desc>
            <path d="M705.440041,283.394034 C705.440041,286.925424 702.586694,289.78861 699.064898,289.78861 C695.544184,289.78861 692.689755,286.925424 692.689755,283.394034 C692.689755,279.863186 695.544184,277 699.064898,277 C702.586694,277 705.440041,279.863186 705.440041,283.394034 L705.440041,283.394034 Z M656.615143,341.228339 L646,341.228339 L646,289.78861 C646,286.344542 648.07349,283.234034 651.241592,281.925831 C654.419429,280.599729 658.061286,281.321627 660.491173,283.759051 L699.075714,322.454644 L737.638082,283.759051 C740.069051,281.321627 743.710367,280.599729 746.888745,281.925831 C750.056306,283.234034 752.129796,286.344542 752.129796,289.78861 L752.129796,341.228339 L741.514112,341.228339 L741.514112,294.912407 L705.065796,331.466169 C703.47201,333.064 701.310367,333.961627 699.054082,333.961627 C696.811857,333.961627 694.656704,333.064 693.063459,331.466169 L656.615143,294.912407 L656.615143,341.228339 L656.615143,341.228339 Z" id="path-1"></path>
          </svg>
        </router-link>
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  props: ['close']
}
</script>

<style lang="scss">
  header {
    background: var(--color-primary);
    color: #fff;
    h1 {
      text-align:center;
      margin:0;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .header__logo {
    width: 40px;
    height: auto;
    padding-top: 10px;
    transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
    path {
      fill:#fff
    }
  }
  .close {
    .header__logo {
      width: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?4c1debe4